<template>

    <div>

        <div
            v-for="help in tempHelp !== null ? tempHelp : helps"
            class="modal fade"
            :id="'modal-house_type-' + help.id"
        >
            <div class="modal-dialog">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title" id="exampleModalLabel">
                            {{ $t('parameters.form.house_subtype.' + help.id) }}

<!--                            {{ help.name }}-->
                        </h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <div ref="swiper" class="swiper-container overflow-hidden position-relative mb-3"
                        >
                            <div class="swiper-wrapper"
                            >
                                <div v-for="img in help.imgs" class="swiper-slide"
                                >
                                    <img :src="'/img/repro/types/' + img" class="img-fluid rounded">
                                </div>
                            </div>

                            <div class="swiper-button-prev"></div>
                            <div class="swiper-button-next"></div>
                            <div class="swiper-pagination"></div>
                        </div>

                        <p class="mb-0">
                            {{ $t('parameters.form.house_subtype.help.' + help.id) }}
                        </p>
                    </div>
                </div>
            </div>
        </div>

    </div>

</template>

<script>
import Swiper from 'swiper/swiper-bundle';

export default {
    name: 'ReproductionHelpModal',
    props: {
        houseTypesModel: {
            type: String,
            required: true,
        },
        propertyTypeModel: {
            type: String,
            required: true
        }
    },
    data() {
        return {
            helps: [
                {
                    id: 'individual',
                    name: 'Samostatný',
                    imgs: ['rodinne-domy-samostatne1.png', 'rodinne-domy-samostatne2.png', 'rodinne-domy-samostatne3.png'],
                    desc: 'Jedná se o samostatně stojící rodinný dům.',
                },
                {
                    id: 'semi_detached',
                    name: 'Dvojdomek',
                    imgs: ['rodinne-domy-dvojdomy.png',],
                    desc: 'Rodinný dům, který sdílí jednu společnou stěnu s vedlejším domem.',
                },
                {
                    id: 'row_house',
                    name: 'Řadový',
                    imgs: ['rodinne-domy-radove.png',],
                    desc: 'Rodinné domy, které jsou řazeny těsně vedle sebe a sdílí nosné zdi se sousedním domem.',
                },
                {
                    id: 'hut',
                    name: 'Chata',
                    imgs: ['chata1.png', 'chata2.png'],
                    desc: 'Stavba, která je určená k individuální rekreaci. Může být podsklepená a má nejvýše jedno nadzemní podlaží a podkroví.',
                },
                {
                    id: 'cottage',
                    name: 'Chalupa',
                    imgs: ['chalupa1.png', 'chalupa2.png'],
                    desc: 'Stavba, která je určena nejen pro rekreaci, ale i pro případné celoroční bydlení.',
                },
                {
                    id: 'unified_panel',
                    name: 'Panelový',
                    imgs: ['bytove-domy-panelove1.png', 'bytove-domy-panelove2.png'],
                    desc: 'Klasický panelový bytový dům 20. století, jehož konstrukce je montována z železobetonových prefabrikovaných dílů.',
                },
                {
                    id: 'unified_other',
                    name: 'Typový',
                    imgs: ['bytove-domy-typove1.png', 'bytove-domy-typove2.png'],
                    desc: 'Bytové domy, u nichž se výstavba opakuje (mají daný typ, půdorys, který se několikrát opakuje, popřípadě je pouze lehce upraven na základě přání zákazníka). Konstrukční systém je jakýkoliv kromě panelové výstavby Např. velký developerský projekt, kde jsou použity 2 typy bytového domu, které se na parcele několikrát opakuje.',
                },
                {
                    id: 'atypical',
                    name: 'Netypový',
                    imgs: ['bytove-domy-netypove1.png', 'bytove-domy-netypove2.png'],
                    desc: 'Bytové domy, který mají jedinečný tvar a půdorys (jsou postaveny pouze jednou). Konstrukční systém je jakýkoliv kromě panelové výstavby.',
                },
            ],
            tempHelp: null,
        }
    },
    methods: {
        initSwiper: function () {
            new Swiper(this.$refs.swiper, {
                direction: 'horizontal',
                navigation: {
                    nextEl: '.swiper-button-next',
                    prevEl: '.swiper-button-prev',
                },
            });
        }
    },
    mounted() {
        this.initSwiper();
        this.tempHelp = this.helps.slice(0, 3);
    },
    watch: {
        'propertyTypeModel'() {
            if (this.propertyTypeModel === 'property_type-family_house') {
                this.tempHelp = this.helps.slice(0, 3);
            }
            if (this.propertyTypeModel === 'property_type-recreational') {
                this.tempHelp = this.helps.slice(3, 5);
            }
            if (this.propertyTypeModel === 'property_type-apartment_house') {
                this.tempHelp = this.helps.slice(5, 8);
            }

            this.initSwiper();
        },
    }
}
</script>
